<template style='text-align:left'>

  <v-layout column>   
    <v-flex xs12>
      <v-layout row  py-0 my-0>
        <v-flex ml-0 xs4 py-0 my-0>
          <EditPlace v-bind:place='servicePlace' v-bind:suppressPlaceExtra='true' 
           v-bind:suppressDelete='true' v-bind:prompt='"Place of service"'/>
        </v-flex>
        <v-flex xs6 mx-0 pt-0> From/to
          <v-card color="indigo" dark flat>
            <EditDateMaybeRange v-bind:container='servicePlace' v-bind:dateProp="'dateRange'" v-bind:alwaysRange="true"/>
          </v-card>
        </v-flex>
        <v-flex xs2 mx-2 pt-0>  
          Days<BR/><input type="number" v-model="servicePlace.days" min="0" max="5000" style='border:1px solid #888888;padding:4px'/>                
        </v-flex>
      </v-layout>
    </v-flex>  
  </v-layout>
</template>        

<script>

import EditPlace from "./EditPlace" ; 
import EditDateMaybeRange from "./EditDateMaybeRange" ; 

export default {

  components: { EditPlace, EditDateMaybeRange },
  props: {
    servicePlace: null,
    person: null
  },

  data () {
    return {
    }    
  },

  async created () {
  },

  async mounted () {
  },

  methods: {
    /*
    createSkeletalBioEntry (defaultDate) {

      // go through the steps adding any needed minimal props.  Any existing props are left as is (!  TODO !?)

      for (let step of this.steps) {
        switch (step.type) {
          case 's': break ; // string
          case 't':
            if (!this.bio[step.prop] && defaultDate) {              
              let i = defaultDate.indexOf(" -") ;
              if (i > 0) defaultDate = defaultDate.substring(0, i) ;
              this.bio[step.prop] = defaultDate + "T09:00" ;
            }
            break ;
          case 'd':
            if (!this.bio[step.prop] && defaultDate) {
              let i = defaultDate.indexOf(" -") ;
              this.bio[step.prop] = (i > 0) ? defaultDate.substring(0, i) : defaultDate ;
            }
            break ;            
          case 'p':
            if (!this.bio[step.prop]) this.bio[step.prop] = {"rid":-1, "town": {"id":-1, "v":null}, "state": {"id": -1, "v":null}, "country": {"id": -1, "v":null}} ;
            break ;
          case 'u':
            if (!this.bio[step.prop]) this.bio[step.prop] = {"rid": -1, "id": -1, "v" :""} ;
            break ;
          case 'r':
            if (!this.bio[step.prop]) this.bio[step.prop] = {"rid": -1, "id": -1, "v" :""} ;
            break ; 
          case 'c':
            if (!this.bio[step.fld]) this.bio[step.fld] = {"rid": -1, "id": -1, "v" :""} ; // was an array, I know..
            break ;   
          case 'x':
            if (!this.bio[step.prop]) {
              const textVal = {"rid": -1}   ;
              textVal[step.fld] = "" ; // typically sv1
              this.bio[step.prop] = textVal ;
            }
            break ; 
          case ':': // dummy prompt step - ignire
            break ;                      
          default:
            console.log("createSkeletalBioEntry didnt understand step " + JSON.stringify(step)) ;
        }
      }
    },
    */
    addSinglyOccuringNoncodeProp (propName, defaultValue) {
      this.bio[propName] = defaultValue ;
      this.$forceUpdate() ;   // shouldnt have to do this..
    }
  }
}
</script>

<style>
.lite {color:#aaaaaa} ;
</style>



// WEBPACK FOOTER //
// src/components/Person/EditServicePlace.vue